<template>
  <div>
    <a 
    target="__blank"
    :href="dataField['link']"
    >
    <img
      :style="dataField['style']"
      :class="dataField['class']"
      :src="dataField['src']" 
    />
    </a>
  </div>
</template>

<script>
export default {
  props: ["dataField"],
  name: "ImageBox",
  data: () => ({}),
};
</script>
